import React, { useEffect, useState } from "react";
import "./ImagePreview.css";

const ImageLightbox = ({ src, alt, onClose }) => {
  // Close on Escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);
 
  return (
    <div
      className="lightbox-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Image preview"
    >
      <div
        className="lightbox-content"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking the image
      >
        <button
          className="lightbox-close"
          onClick={onClose}
          aria-label="Close preview"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <img src={src} alt={alt || "Visit image"} className="lightbox-image" />
      </div>
    </div>
  );
};
 
// ── Thumbnail with preview trigger ───────────────────────────────────────────
const PreviewImage = ({ src, alt }) => {
  const [open, setOpen] = useState(false);
 
  return (
    <>
      <div className="route-his-img-wrapper" onClick={() => setOpen(true)}>
        <img src={src} alt={alt || "Visit image"} className="route-his-img" />
        <div className="route-his-img-overlay" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
            <line x1="11" y1="8" x2="11" y2="14" />
            <line x1="8" y1="11" x2="14" y2="11" />
          </svg>
        </div>
      </div>
 
      {open && (
        <ImageLightbox src={src} alt={alt} onClose={() => setOpen(false)} />
      )}
 
    </>
  );
};
export default PreviewImage;